// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__dA0sZ","title":"index_title__lEf3T","tips":"index_tips__B7oPw","darkTip":"index_darkTip__P3did","darkTheme":"index_darkTheme__uRmTU"};